import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { discardBooking } from 'redux/actions/booking';

export const ExpiredMessage = ({ bookingDidExpire }) => {
  const dispatch = useDispatch();

  const handleOnClick = () => {
    let handleDefault = true;

    if (typeof bookingDidExpire === 'function') {
      handleDefault = bookingDidExpire();
    }

    if (handleDefault) {
      return dispatch(discardBooking()).then(() => {
        window.location.assign('/');
      });
    }
    return Promise.resolve();
  };

  const expiryMessage = 'Your booking has expired!';
  const buttonText = 'Start over';

  return (
    <div className="space-y-2">
      <div className="text-small">{expiryMessage}</div>
      <button
        type="button"
        className="btn  btn-light btn-sm"
        onClick={handleOnClick}
      >
        {buttonText}
      </button>
    </div>
  );
};

ExpiredMessage.propTypes = {
  bookingDidExpire: PropTypes.func,
};
